<template>
  <div>
    <div class="error">
      <div class="callout alert" v-if="errors.length > 0">
        Bitte korrigieren Sie die rot markierten Felder.
      </div>
    </div>
    <div class="participant row">
      <div class="field field-select gender col s50">
        <label for="gender" :class="checkError('gender')">Geschlecht</label>
        <select id="gender" name="gender" v-model="participantProxy.gender">
          <option value="" selected></option>
          <option value="diverse">Divers</option>
          <option value="male">Männlich</option>
          <option value="female">Weiblich</option>
        </select>
      </div>
      <div class="field field-text dateOfBirth col s50">
        <label for="dateOfBirth" :class="checkError('dateOfBirth')"
          >Geburtstag</label
        >
        <input
          type="date"
          id="dateOfBirth"
          name="dateOfBirth"
          v-model="participantProxy.dateOfBirth"
        />
      </div>
      <div class="field field-text firstname col m50">
        <label for="firstname" :class="checkError('lastname')">Vorname</label>
        <input
          type="text"
          id="firstname"
          name="firstname"
          v-model="participantProxy.firstname"
        />
      </div>
      <div class="field field-text lastname col m50">
        <label for="lastname" :class="checkError('lastname')">Nachname</label>
        <input
          type="text"
          id="lastname"
          name="lastname"
          v-model="participantProxy.lastname"
        />
      </div>
      <!--
      <div class="field field-textarea moreInformation col">
        <label for="moreInformation">Weitere Informationen zum Teilnehmer</label>
        <textarea
          id="moreInformation"
          name="moreInformation"
          v-model="participantProxy.moreInformation"
        ></textarea>
      </div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Participant",
  props: ["participant"],
  data() {
    return {
      participantValue: this.participant,
      errors: []
    };
  },
  computed: {
    participantProxy: {
      set: function(value) {
        this.participantValue = value;
        this.$emit("update:participant", this.participantValue);
      },
      get: function() {
        return this.participantValue;
      }
    }
  },
  methods: {
    checkForm() {
      let errors = [];
      if (
        this.participantProxy.gender === undefined ||
        this.participantProxy.gender === ""
      )
        errors.push("gender");
      if (
        this.participantProxy.firstname === undefined ||
        this.participantProxy.firstname === ""
      )
        errors.push("firstname");
      if (
        this.participantProxy.lastname === undefined ||
        this.participantProxy.lastname === ""
      )
        errors.push("lastname");
      if (
        this.participantProxy.dateOfBirth === undefined ||
        this.participantProxy.dateOfBirth === "" ||
        !/^\d{4}[-]\d{2}[-]\d{2}$/.test(this.participantProxy.dateOfBirth)
      )
        errors.push("dateOfBirth");

      this.errors = errors;
      return this.errors.length === 0;
    },
    checkError(field) {
      return this.errors.indexOf(field) !== -1 ? "error" : "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
